<template>
<!--  <div class="index" :style="imgShow ? 'background-image:' + 'url(' + bgImg + ');background-size:cover' : ''">-->
  <div class="index">
    <img src="http://intai-website2.oss-us-west-1.aliyuncs.com/intai/word/2023/09/09/6c43c01f-0f27-44f6-ae88-3d8e7120bacd.png?Expires=1851903393&OSSAccessKeyId=LTAI5tKV79uqHw2dDWk3toPr&Signature=W4oDN5tooAB107c%2BkXjDgRf02VI%3D" class="searchImg" @click="inputFocus">
    <div class="searchBg" :style="{'display':( isShowSearchBox === true ?'block': 'none') }">
      <div class="searchBox"  :style="{'display':( isShowSearchBox === true ?'block': 'none') }">
        <img src="http://intai-website2.oss-us-west-1.aliyuncs.com/intai/word/2023/09/09/848cbcd8-43f9-48a9-bcdd-87233e9de787.png?Expires=1851903499&OSSAccessKeyId=LTAI5tKV79uqHw2dDWk3toPr&Signature=AAAgN2xLUen0hXM%2FpWU0UfN5mwE%3D" alt="" class="close" @click="closeSearch">
        <input class="inputBox" placeholder="Search" v-model.trim="keyWord" ref="customerInput" @keyup.enter="toList" @focus="isBlur = true"  @blur="isBlur = false"  :style="{'border-bottom':( isBlur === true ?'1px #000 dotted!important': '1px solid #d8d7d5') }"/>
       <template v-if="isShowResult">
          <div class="result" v-if="resultList.length > 0">
            <div class="resultList">
              <span v-for="(item, index) in resultList" :key="index"  @click="toSearch(index)">{{ item.storyName }}({{item.storyData.length}})</span>
            </div>
          </div>
          <div class="result" v-else>
            <span>no result</span>
          </div>
       </template>
      </div>
    </div>
    <div class="left">
      <img src="http://intai-website2.oss-us-west-1.aliyuncs.com/intai/word/2023/09/09/aa438cde-05af-4bfb-8918-0e9c843b28ef.png?Expires=1851902893&OSSAccessKeyId=LTAI5tKV79uqHw2dDWk3toPr&Signature=J9DGF%2BA%2FRKrsvq8AK2ATbHYmGBg%3D" alt="" class="logo" @click="toHome">
      <Sidebar :menuList="menuList"/>
    </div>
    <div class="right">
      <router-view/>
    </div>
  </div>
</template>
<script>
import { getNavList, search } from '@/api'
import Sidebar from '../components/SideBar'
export default {
  name: 'Index',
  components: { Sidebar },
  watch: {
    keyWord () {
      if (this.keyWord.length > 2) {
        search(this.keyWord).then(res => {
          if (res.data.code === 200) {
            // console.log(res)
            this.isShowResult = true
            if (res.data.data.length > 0) {
              this.resultList = res.data.data
            } else {
              this.resultList = []
              sessionStorage.removeItem('searchObj')
            }
          } else {
            this.isShowResult = false
            this.resultList = []
            sessionStorage.removeItem('searchObj')
          }
        }).catch(err => {
          console.log(err)
          sessionStorage.removeItem('searchObj')
        })
      } else {
        this.isShowResult = false
        this.resultList = []
        sessionStorage.removeItem('searchObj')
      }
    },
    '$route.path': { // 监听路由切换导航激活变化
      handler (newVal, oldVal) {
        // 判断newVal有没有值监听路由变化
        if (newVal === '/Home') {
          this.imgShow = true
        } else {
          this.imgShow = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      bgImg: 'http://intai-website2.oss-us-west-1.aliyuncs.com/intai/word/2023/09/09/a81bfa71-0a26-47f1-9512-7eed55fbf09d.gif?Expires=1851902934&OSSAccessKeyId=LTAI5tKV79uqHw2dDWk3toPr&Signature=8IXzemzgqgSwp5vtlp3KL791apI%3D',
      imgShow: true,
      menuList: [{
        id: 1,
        name: 'OUR WORK',
        children: []
      },
      {
        id: 15,
        name: 'THE COMPANY',
        children: []
      },
      {
        id: 20,
        name: 'LINK',
        children: [],
        pageType: '7'
      }],
      keyWord: '', // 关键字搜索
      isShowSearchBox: false, // 搜索框显示
      isBlur: false, // input是否聚焦
      isShowResult: false, // 搜索结果展示
      resultList: [] // 搜索结果数据
    }
  },
  methods: {
    // 展开搜索框
    inputFocus () {
      this.keyWord = ''
      this.isShowSearchBox = true
      this.$nextTick(() => {
        this.$refs.customerInput.focus()
      })
    },
    closeSearch () {
      this.isShowSearchBox = false
      this.isShowResult = false
      this.keyWord = ''
      this.resultList = []
      this.$nextTick(() => {
        this.$refs.customerInput.blur()
      })
    },
    toSearch (index) {
      sessionStorage.setItem('searchObj', JSON.stringify(this.resultList[index]))
      this.isShowSearchBox = false
      this.isShowResult = false
      this.resultList = []
      this.$nextTick(() => {
        this.$refs.customerInput.blur()
      })
      this.$router.push({
        path: '/Search',
        query: { keyWord: this.keyWord }
      })
    },
    toHome () {
      this.$router.push('/')
      this.$bus.$emit('closeNav1')
    },
    toList () {
      if (this.keyWord === '') {
        this.$message.warning('Please enter the name of the product you want to search!')
      } else {
        // console.log(this.resultList)
        if (this.resultList.length > 0) {
          var obj = {
            storyName: this.keyWord,
            storyData: []
          }
          for (var i = 0; i < this.resultList.length; i++) {
            obj.storyData = obj.storyData.concat(this.resultList[i].storyData)
          }
          // console.log(obj)
          sessionStorage.setItem('searchObj', JSON.stringify(obj))
          this.isShowSearchBox = false
          this.isShowResult = false
          this.resultList = []
          this.$nextTick(() => {
            this.$refs.customerInput.blur()
          })
          this.$router.push({
            path: '/Search',
            query: { keyWord: this.keyWord }
          })
        }
      }
    }
  },
  created () {
    getNavList().then(res => {
      if (res.data.code === 200) {
        // console.log(res)
        this.menuList = res.data.data
      }
    }).catch(err => {
      console.log(err)
    })
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.index{
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  .searchImg{
    position: absolute;
    width: 21px;
    top: 10px;
    right: 40px;
    z-index: 9;
  }
  @keyframes isShow
  {
    from {transform: translateY(-100%)}
    to { transform: translateY(0)}
  }

  /*Safari 和 Chrome:*/
  @-webkit-keyframes isShow
  {
    from {transform: translateY(-100%)}
    to { transform: translateY(0)}
  }
  .searchBg{
    width:100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    display: none;
  }
  .searchBox {
    position: absolute;
    width: 100%;
    min-height: 200px;
    background-color: #fff;
    animation:isShow 0.5s linear ;
    /*Safari 和 Chrome:*/
    -webkit-animation:isShow 0.5s forwards linear ;
    z-index: 999;
    .close{
      position: absolute;
      right: 40px;
      top: 30px;
      width: 25px;
    }
    .inputBox {
      position: absolute;
      width: 340px;
      height:20px;
      top: 130px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      //border-bottom: 1px solid #d8d7d5!important;
      //&:hover{
      //  border-bottom: 1px #000 solid!important;
      //}
    }
    .result{
      width: 100%;
      text-align: center;
      position: absolute;
      font-size: 14px;
      top: 165px;
      .resultList{
        background: #fff;
        display: flex;
        flex-direction: column;
        padding-bottom:  30px;
        text-align: center;
        span{
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
    }
  }
  .left{
    position: relative;
    width: 450px;
    padding: 30px 10px 30px 30px;
    box-sizing: border-box;
    height: 100vh;
    overflow: auto;
    .logo{
      position: absolute;
      width: 250px;
      cursor: pointer;
    }
  }
  .right{
    flex: 1;
    box-sizing: border-box;
    padding: 40px 20px 40px 0;
    height: 100vh;
    overflow: auto;
  }
  ::-webkit-scrollbar {display:none}
}
</style>
